import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';

export default function MonthPicker({ onChange }) {
  // If no selectedMonth or selectedYear is passed, use the current month and year
  const currentDate = new Date();
  const [month, setMonth] = useState( currentDate.getMonth() + 1); // 0-based index (0 = January)
  const [year, setYear] = useState( currentDate.getFullYear());


  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth); // Update local state for the month
    console.log(newMonth, year)
    onChange(newMonth, year); // Pass updated month and current year to parent
  };

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setYear(newYear); // Update local state for the year
    onChange(month, newYear); // Pass updated month and year to parent
  };

  return (
    <div className="flex items-center space-x-2">
      <Calendar className="h-5 w-5 text-gray-500" />

      {/* Month Picker */}
      <select
        value={month}
        onChange={handleMonthChange}
        className="px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="01">January</option>
        <option value="02">February</option>
        <option value="03">March</option>
        <option value="04">April</option>
        <option value="05">May</option>
        <option value="06">June</option>
        <option value="07">July</option>
        <option value="08">August</option>
        <option value="09">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
      </select>

      {/* Year Picker */}
      <select
        value={year}
        onChange={handleYearChange}
        className="px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        {[2024, 2025, 2026].map((yearOption) => (
          <option key={yearOption} value={yearOption}>
            {yearOption}
          </option>
        ))}
      </select>
    </div>
  );
}
